// helpers.js
import { camelCase } from 'lodash';

export const mapCartTotalsResponseToCamelCase = (responseData) => {
  const allowedKeys = [
    'total',
    'shipping',
    'tax',
    'serviceFee',
    'serviceFeeDescription',
    'discount',
    'familyDiscount',
    'grandTotal',
    'cartTotalsObject',
    'voucherAvailableCents',
    'voucherAppliedCents',
    'voucherPurchaseSubtotalCents',
  ];

  const mappedData = {};

  for (const key in responseData) {
    if (responseData.hasOwnProperty(key)) {
      const camelKey = camelCase(key);
      if (allowedKeys.includes(camelKey)) {
        mappedData[camelKey] = responseData[key];
      }
    }
  }
  return mappedData;
};
